import * as React from "react";
import type { SVGProps } from "react";
const SvgShieldCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#shield-check_svg__a)">
      <path d="M12 21.99c-.17 0-.34-.04-.49-.13-.11-.06-2.83-1.58-4.2-2.74C4.69 16.92 3.02 13.75 3 11V7.47c0-1.21.01-2.43 0-3.46 0-.42.25-.79.64-.94 1.65-.63 4.63-1.02 8.2-1.07 3.32-.05 6.66.38 8.51 1.06.39.14.65.51.65.93v7c.02 3.28-2.11 6.3-4.12 8.04-1.41 1.22-4.28 2.78-4.4 2.85q-.225.12-.48.12zM5.01 4.73v6.26c.01 2.15 1.44 4.79 3.55 6.57.94.79 2.63 1.8 3.45 2.28.85-.48 2.62-1.52 3.52-2.29 2.14-1.85 3.48-4.4 3.47-6.55V4.73c-1.72-.47-4.51-.77-7.14-.73-2.8.03-5.32.31-6.85.72z" />
      <path d="M11 16c-.31 0-.61-.15-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4s1.07-.24 1.4.2l2.12 2.83 4.23-6.76a1.003 1.003 0 0 1 1.7 1.06l-5 8a.99.99 0 0 1-.81.47z" />
    </g>
    <defs>
      <clipPath id="shield-check_svg__a">
        <path fill="#fff" d="M3 2h18v19.99H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgShieldCheck;
